import React, { useEffect, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import { Modal, Row, Col, Card, Placeholder } from 'react-bootstrap';
import { formatDateTime } from '../orders/OrderComponent';
import { AccountbilityApi } from '../../app/api/accountbility.api';
import '../orders/Order.css';
import { ExpenseApi } from '../../app/api/expense.api';
import { debtsType, expensesType } from './accountbilityData'
import { DebtApi } from '../../app/api/debt.api';


export function HeaderSection ({ active }) 
{
  return (  

    <div className="border bg-white text-secondary rounded-3 my-4">
      <div className="d-flex justify-content-between flex-column flex-md-row align-items-center border-bottom px-4 py-3 fs-5 gap-3">
        <span> <i className="bi bi-receipt me-2"></i> Comptabilité  </span>
      </div>  
      <div className="d-flex flex-column">
        <nav className="navbar navbar-expand-sm">
          <div className="container-fluid">
            <button className="navbar-toggler small" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav2" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon small"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav2">
              <ul className="navbar-nav my-2 px-3 gap-3">
                <li>
                  <a className={`btn btn-sm rounded-0 px-3 ${(active===1) ? 'btn-green' : 'btn-outline-green'}`} href="/comptabilite"> Statistique </a>
                </li>
                <li>
                  <a className={`btn btn-sm rounded-0 px-3 ${(active===2) ? 'btn-green' : 'btn-outline-green'}`} href="/depense"> Dépenses </a>
                </li>
                 <li>
                  <a className={`btn btn-sm rounded-0 px-3 ${(active===3)  ? 'btn-green' : 'btn-outline-green'}`} href="/creance"> Créances </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
       </div> 
     </div>
  );
        
}


export function AddExpenseModal({ show, onHide, refetch})
{
  const expenses = ExpenseApi('multipart/form-data');

  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({
    type: '',
    description: '',
    amount: '',
    document: null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'document') {
      setInputs({ ...inputs, document: files[0] });
    } else {
      setInputs({ ...inputs, [name]: value });
    }
  };

  useEffect(() => {
    if (show) {
      setStatus(null);    
      setMessage("");
      setIsLoading(false);
    }
  }, [show]);


  const handleSubmit  = async (event) => {

    event.preventDefault();
    setStatus(0);
    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append('type', inputs.type);
      formData.append('description', inputs.description);
      formData.append('amount', inputs.amount);

      if (inputs.document) {
        formData.append('document', inputs.document);
      }
      const {data} = await expenses.insert(formData);
    
              
      if(data.success){
          setStatus(1);
          setMessage(data.message);
          setInputs({
            type: '',
            description: '',
            amount: '',
            document: null
          });
          refetch();
      }  
      else{ 
          setStatus(-1);
          setMessage('Erreur, veuillez réessayer'); 
      }

    } catch (err) {
        setStatus(-1);      
        const response = err?.response?.data;

        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
           setMessage(response.errors[0].msg || response.errors[0]);
         } else {
           setMessage("Une erreur est survenue. Veuillez réessayer.");
         }
    }
    finally{
       setIsLoading(false);
    }
  };


  return(
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
    <form onSubmit={handleSubmit} encType="multipart/form-data">

      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="text-green fs-5 ps-4">
          <i className="bi bi-plus-circle me-2"></i>
          Ajouter une dépense
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="row justify-content-center p-4">
        
        <div className="expense-form col-md-11">
          {
            isLoading && (
              <div className="d-flex justify-content-center mb-2"> 
                <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
              </div>
            )
          }
          {
            status === 1 && (
              <div className="alert alert-success mb-2 w-100 small"> { message } </div>
            )
          }
          {
            status === -1 && (
              <div className="alert alert-danger mb-2 w-100 small"> { message } </div>
            )
          }
          <div className="mb-1">
            <label className="small mb-1 text-secondary">Type</label>
            <select 
              className="border p-2 w-100 text-muted" 
              name="type"
              value={inputs.type}
              onChange={handleChange}
            >
              <option value="">Sélectionnez un type</option>
              {
                expensesType.map( (item, index) => (
                    <option key={index} value={item.name}> {item.name} </option>
                ) )
              }
            </select>
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">Description</label>
            <textarea 
              className="border p-2 w-100 text-muted" 
              rows="4"
              name="description"
              value={inputs.description}
              onChange={handleChange}
              placeholder="Décrivez la dépense..."
            ></textarea>
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">Montant</label>
            <input 
              type="number" 
              className="border p-2 w-100 text-muted"
              name="amount"
              value={inputs.amount}
              onChange={handleChange}
              placeholder="0.00"
            />
          </div>

          <div className="mb-2">
            <label className="small mb-1 text-secondary">Document (PDF uniquement)</label>
            <input 
              type="file" 
              className="border p-2 w-100 text-muted"
              name="document"
              onChange={handleChange}
              accept=".pdf"
            />
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer className="border-top gap-2">
        <button className="btn btn-sm btn-outline-danger px-3" onClick={onHide}>Annuler</button>
        <button className="btn btn-sm btn-green px-3" type='submit'>
          <i className="bi bi-check-circle me-2"></i>
          Ajouter
        </button>
      </Modal.Footer>

    </form>
    </Modal>
  )
}


export function EditExpenseModal({ show, onHide, expense, refetch })
{
  const expenses = ExpenseApi('multipart/form-data');

  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({
    type: expense?.type || '',
    description: expense?.description || '',
    amount: expense?.amount || '',
    document: null
  });

  useEffect(() => {
    if (expense) {
      setInputs({
        type: expense.type || '',
        description: expense.description || '',
        amount: expense.amount || '',
        document: null
      });
    }
  }, [expense]);


  useEffect(() => {
    if (show) {
      setStatus(null);    
      setMessage("");
      setIsLoading(false);
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'document') {
      setInputs({ ...inputs, document: files[0] });
    } else {
      setInputs({ ...inputs, [name]: value });
    }
  };


  const handleSubmit  = async (event) => {

    event.preventDefault();
    setStatus(0);
    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append('type', inputs.type);
      formData.append('description', inputs.description);
      formData.append('amount', inputs.amount);

      if (inputs.document) {
        formData.append('document', inputs.document);
      }
      const {data} = await expenses.update(expense?.id, formData);
            
      if(data.success){
          setStatus(1);
          setMessage(data.message);
          refetch();
      }  
      else{ 
          setStatus(-1);
          setMessage('Erreur, veuillez réessayer'); 
      }

    } catch (err) {
        setStatus(-1);      
        const response = err?.response?.data;

        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
           setMessage(response.errors[0].msg || response.errors[0]);
         } else {
           setMessage("Une erreur est survenue. Veuillez réessayer.");
         }
    }
    finally{
       setIsLoading(false);
    }
  };


  return(
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
    <form onSubmit={handleSubmit} encType="multipart/form-data">
    
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="text-green fs-5 ps-4">
          <i className="bi bi-pencil-square me-2"></i>
          Modifier la dépense
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="row justify-content-center p-4">
        <div className="expense-form col-md-11">
          {
            isLoading && (
              <div className="d-flex justify-content-center mb-2"> 
                <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
              </div>
            )
          }
          {
            status === 1 && (
              <div className="alert alert-success mb-2 w-100 small"> { message } </div>
            )
          }
          {
            status === -1 && (
              <div className="alert alert-danger mb-2 w-100 small"> { message } </div>
            )
          }
          <div className="mb-1">
            <label className="small mb-1 text-secondary">Type</label>
            <select 
              className="border p-2 w-100 text-muted" 
              name="type"
              value={inputs.type}
              onChange={handleChange}
            >
              <option value="">Sélectionnez un type</option>
              {
                expensesType.map( (item, index) => (
                    <option key={index} value={item.name}> {item.name} </option>
                ) )
              }
            </select>
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">Description</label>
            <textarea 
              className="border p-2 w-100 text-muted" 
              rows="4"
              name="description"
              value={inputs.description}
              onChange={handleChange}
              placeholder="Décrivez la dépense..."
            ></textarea>
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">Montant</label>
            <input 
              type="number" 
              className="border p-2 w-100 text-muted"
              name="amount"
              value={inputs.amount}
              onChange={handleChange}
              placeholder="0.00"
            />
          </div>

          <div className="mb-2">
            <label className="small mb-1 text-secondary">Document (PDF uniquement)</label>
            <input 
              type="file" 
              className="border p-2 w-100 text-muted"
              name="document"
              onChange={handleChange}
              accept=".pdf"
            />
          </div>

          {expense?.document && (
            <div className="mb-3 p-3 bg-light border rounded">
              <p className="text-muted small mb-2">Document actuel</p>
              <a href={expense?.document} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-green">
                <i className="bi bi-file-pdf me-2"></i>
                Ouvrir le fichier
              </a>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top gap-2">
        <button className="btn btn-sm btn-outline-danger px-3" onClick={onHide}>Annuler</button>
        <button className="btn btn-sm btn-green px-3" type='submit'>
          <i className="bi bi-check-circle me-2"></i>
          Modifier
        </button>
      </Modal.Footer>

    </form>
    </Modal>
  )
}


export function ViewExpenseModal({ show, onHide, expense })
{
  return(
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="text-green fs-5 ps-4">
          <i className="bi bi-eye me-2"></i>
          Détails de la dépense
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="row justify-content-center p-4">
        <div className="expense-details col-md-11">
          <div className="d-flex align-items-center gap-3 mb-3 pb-2 border-bottom">
            <span className="text-muted"> Type de dépense : </span>
            <span className="text-secondary fw-bold">{ expense?.type }</span>
          </div>

          <div className="mb-3 pb-2 border-bottom">
            <p className="text-muted small mb-1">Description : </p>
            <div style={{ maxHeight: '200px', overflowY: 'auto', backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '5px' }}>
              <p className="text-secondary">{ expense?.description }</p>
            </div>
          </div>

          <div className="d-flex gap-3 pb-3 border-bottom mb-3">
            <div className="d-flex flex-column align-items-center border-bottom border py-3 px-4">
              <p className="text-muted small mb-1">Montant officiel </p>
              <span className="text-secondary fw-bold">{ expense?.amount } Fcfa </span>
            </div>
             
            <div className="d-flex flex-column align-items-center border-bottom border py-3 px-4">
                <p className="text-muted small mb-1">Montant modifié</p>
                {
                  expense?.admin !== null && ( 
                    <span className="text-secondary fw-bold">{ expense?.oldAmount } Fcfa </span>
                 ) 
                }
            </div>
          </div>

          {/*  */}
          <div className="d-flex pb-3 border-bottom mb-3">
            {
              expense?.admin !== null && (          
                <div className="d-flex w-100 p-2 bg-success bg-opacity-10 rounded">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-info-circle text-green"></i>
                    <span className="text-green small"> Créance modifiée par : { expense?.admin } le : { formatDateTime( expense?.updatedAt ) } </span>
                  </div>
                </div>
              )
            }
          </div>

          {/*  */}
          <div className="d-flex gap-3">
            <div className="d-flex flex-column align-items-center border-bottom border py-3 px-4">
              <p className="text-muted small mb-2">Document officiel </p>
              <a href={expense?.document} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-green px-3">
                  <i className="bi bi-file-pdf me-2"></i>
                  Ouvrir
              </a>
            </div>   
           
            <div className="d-flex flex-column align-items-center border-bottom border py-3 px-4">
              <p className="text-muted small mb-2">Document modifié</p>
              {
                  expense?.admin !== null && (
                    <a href={expense?.oldDocument} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-green px-3">
                       <i className="bi bi-file-pdf me-2"></i>
                       Ouvrir
                    </a> 
                  )
              }
            </div>   
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer className="border-top gap-2">
        <button className="btn btn-sm btn-green px-3 me-4" onClick={onHide}>Fermer</button>
      </Modal.Footer>
    </Modal>
  )
}


export function AddDebtModal({ show, onHide, refetch })
{
  const debt = DebtApi();

  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    type: '',
    description: '',
    amount: '',
    name: '',
    cni: '',
    phone: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    if (show) {
      setStatus(null);    
      setMessage("");
      setIsLoading(false);
    }
  }, [show]);


  const handleSubmit  = async (event) => {

    event.preventDefault();
    setStatus(0);
    setIsLoading(true);

    try {

      const {data} = await debt.insert(formData);
    
              
      if(data.success){
          setStatus(1);
          setMessage(data.message);
          setFormData({
            type: '',
            description: '',
            amount: '',
            name: '',
            cni: '',
            phone: ''
          });
          refetch();
      }  
      else{ 
          setStatus(-1);
          setMessage('Erreur, veuillez réessayer'); 
      }

    } catch (err) {
        setStatus(-1);      
        const response = err?.response?.data;

        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
           setMessage(response.errors[0].msg || response.errors[0]);
         } else {
           setMessage("Une erreur est survenue. Veuillez réessayer.");
         }
    }
    finally{
       setIsLoading(false);
    }
  };




  return(
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
    <form onSubmit={handleSubmit}>
    
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="text-green fs-5 ps-4">
          <i className="bi bi-plus-circle me-2"></i>
          Ajouter une créance
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="row justify-content-center p-4">
        <div className="debt-form col-md-11">
          {
            isLoading && (
              <div className="d-flex justify-content-center mb-2"> 
                <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
              </div>
            )
          }
          {
            status === 1 && (
              <div className="alert alert-success mb-2 w-100 small"> { message } </div>
            )
          }
          {
            status === -1 && (
              <div className="alert alert-danger mb-2 w-100 small"> { message } </div>
            )
          }
          <div className="mb-1">
            <label className="small mb-1 text-secondary">Type</label>
            <select 
              className="border p-2 w-100 text-muted" 
              name="type"
              value={formData.type}
              onChange={handleChange}
            >
              <option value="">Sélectionnez un type</option>
              {
                debtsType.map( (item, index) => (
                    <option key={index} value={item.name}> {item.name} </option>
                ) )
              }
            </select>
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">Description</label>
            <textarea 
              className="border p-2 w-100 text-muted" 
              rows="3"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Décrivez la créance..."
            ></textarea>
          </div>

          <div className="mb-1 d-flex flex-column">
            <label className="small mb-1 text-secondary">Montant</label>
            <input 
              type="number" 
              className="border p-2"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              placeholder="0.00"
            />
          </div>

          <h6 className="p-2 bg-success bg-opacity-10 border my-3 text-green"><i className="bi bi-person-check me-2"></i>Informations du garant</h6>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">Nom du garant</label>
            <input 
              type="text" 
              className="border p-2 w-100 text-muted"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Nom complet"
            />
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">CNI / Numéro d'identité</label>
            <input 
              type="text" 
              className="border p-2 w-100 text-muted"
              name="cni"
              value={formData.cni}
              onChange={handleChange}
              placeholder="Numéro CNI"
            />
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">Téléphone du garant</label>
            <input 
              type="tel" 
              className="border p-2 w-100 text-muted"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+221 XX XXX XX XX"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top gap-3">
        <button className="btn btn-sm btn-outline-danger px-3" onClick={onHide}>Annuler</button>
        <button className="btn btn-sm btn-green px-3 me-4">
          <i className="bi bi-check-circle me-2"></i>
          Ajouter
        </button>
      </Modal.Footer>

    </form>
    </Modal>
  )
}



export function EditDebtModal({ show, onHide, refetch, debt })
{
  const debts = DebtApi();

  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    type: debt?.type || '',
    description: debt?.description || '',
    amount: debt?.amount || '',
    name: debt?.name || '',
    cni: debt?.cni || '',
    phone: debt?.phone || '',
    status: debt?.status || '' 
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    if (show) {
      setStatus(null);    
      setMessage("");
      setIsLoading(false);
    }
  }, [show]);


  const handleSubmit  = async (event) => {

    event.preventDefault();
    setStatus(0);
    setIsLoading(true);

    try {

      const {data} = await debts.update(debt?.id, formData);
    
              
      if(data.success){
          setStatus(1);
          setMessage(data.message);
          refetch();
      }  
      else{ 
          setStatus(-1);
          setMessage('Erreur, veuillez réessayer'); 
      }

    } catch (err) {
        setStatus(-1);      
        const response = err?.response?.data;

        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
           setMessage(response.errors[0].msg || response.errors[0]);
         } else {
           setMessage("Une erreur est survenue. Veuillez réessayer.");
         }
    }
    finally{
       setIsLoading(false);
    }
  };

  useEffect(() => {
    if (debt) {
      setFormData({
        type: debt.type || '',
        description: debt.description || '',
        amount: debt.amount || '',
        name: debt.name || '',
        cni: debt.cni || '',
        phone: debt.phone || '',
        status: debt?.status || '' 
      });
    }
  }, [debt]);

  return(
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
    <form onSubmit={handleSubmit}>
       
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="text-green fs-5 ps-4">
          <i className="bi bi-pencil-square me-2"></i>
          Modifier la créance
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="row justify-content-center p-4">
        <div className="debt-form col-md-11">
          {
            isLoading && (
              <div className="d-flex justify-content-center mb-2"> 
                <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
              </div>
            )
          }
          {
            status === 1 && (
              <div className="alert alert-success mb-2 w-100 small"> { message } </div>
            )
          }
          {
            status === -1 && (
              <div className="alert alert-danger mb-2 w-100 small"> { message } </div>
            )
          }
          <div className="mb-1">
            <label className="small mb-1 text-secondary">Type</label>
            <select 
              className="border p-2 w-100 text-muted" 
              name="type"
              value={formData.type}
              onChange={handleChange}
            >
              <option value="">Sélectionnez un type</option>
              {
                debtsType.map( (item, index) => (
                    <option key={index} value={item.name}> {item.name} </option>
                ) )
              }
            </select>
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">Description</label>
            <textarea 
              className="border p-2 w-100 text-muted" 
              rows="3"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Décrivez la créance..."
            ></textarea>
          </div>

          <div className="mb-1 d-flex flex-column">
            <label className="small mb-1 text-secondary">Montant</label>
            <input 
              type="number" 
              className="border p-2"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              placeholder="0.00"
            />
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary"> Statut de la créance </label>
            <select 
              className="border p-2 w-100 text-muted" 
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="">Sélectionnez le statut</option>
              <option value="pending"> Créance en cours </option>
              <option value="paid"> Créance payée </option>
              <option value="canceled"> Créance annulée </option>
            </select>
          </div>
          <h6 className="p-2 bg-success bg-opacity-10 border my-3 text-green"><i className="bi bi-person-check me-2"></i>Informations du garant</h6>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">Nom du garant</label>
            <input 
              type="text" 
              className="border p-2 w-100 text-muted"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Nom complet"
            />
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">CNI / Numéro d'identité</label>
            <input 
              type="text" 
              className="border p-2 w-100 text-muted"
              name="cni"
              value={formData.cni}
              onChange={handleChange}
              placeholder="Numéro CNI"
            />
          </div>

          <div className="mb-1">
            <label className="small mb-1 text-secondary">Téléphone du garant</label>
            <input 
              type="tel" 
              className="border p-2 w-100 text-muted"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+225 XX XX XX XX"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top gap-2">
        <button className="btn btn-sm btn-outline-danger px-3" onClick={onHide}>Annuler</button>
        <button className="btn btn-sm btn-green px-3" >
          <i className="bi bi-check-circle me-2"></i>
          Modifier
        </button>
      </Modal.Footer>

    </form>
    </Modal>
  )
}


export function ViewDebtModal({ show, onHide, debt })
{
  return(
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="text-green fs-5 ps-4">
          <i className="bi bi-eye me-2"></i>
          Détails de la créance
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="row justify-content-center p-4">
        <div className="debt-details">
          <div className="d-flex align-items-center gap-3 mb-3 pb-2 border-bottom">
            <div className="text-muted"> Type de créance :</div>
            <div className="d-flex align-items-center gap-3">
              <span className="text-secondary fw-bold">{ debt?.type } </span>
              {
                debt?.status === "pending" && <span className="alert alert-warning mb-0 py-0 px-2 small"> En cours </span>
              }
              {
                debt?.status === "paid" && <span className="alert alert-success mb-0 py-0 px-2 small"> Payée </span>
              }
              {
                debt?.status === "canceled" && <span className="alert alert-danger mb-0 py-0 px-2 small"> Annulée </span>
              }
            </div>
          </div>

          <div className="mb-3 pb-2 border-bottom">
            <p className="text-muted small mb-1">Description</p>
            <div style={{ maxHeight: '200px', overflowY: 'auto', backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '5px' }}>
              <p className="text-secondary">{ debt?.description } </p>
            </div>
          </div>

          <div className="d-flex gap-3 pb-3 border-bottom mb-3">
            <div className="d-flex flex-column align-items-center border-bottom border py-3 px-4">
              <p className="text-muted small mb-1">Montant officiel </p>
              <span className="text-secondary fw-bold">{ debt?.amount } Fcfa </span>
            </div>
            <div className="d-flex flex-column align-items-center border-bottom border py-3 px-4">
              <p className="text-muted small mb-1">Montant modifié</p>
              {
                  debt?.admin !== null && (
                      <span className="text-secondary fw-bold">{ debt?.oldAmount } Fcfa </span>
                  )
              }
              
            </div>
          </div>

          {/*  */}
          <div className="d-flex pb-3 border-bottom mb-3">
            {
              debt?.admin !== null && (          
                <div className="d-flex w-100 p-2 bg-success bg-opacity-10 rounded">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-info-circle text-green"></i>
                    <span className="text-green small"> Créance modifiée par : { debt?.admin } le : { formatDateTime( debt?.updatedAt ) } </span>
                  </div>
                </div>
              )
            }
          </div>

          <div className="d-flex flex-column p-3 bg-light border">
              <h6 className="text-secondary mb-3"><i className="bi bi-person-check me-2"></i>Informations du garant</h6>

              <div className="d-flex align-items-center gap-3 mb-2 pb-2 border-bottom">
                <span className="text-muted small">Nom du garant : </span>
                <span className="text-secondary small fw-bold">{ debt?.name } </span>
              </div>

              <div className="d-flex align-items-center gap-3 mb-2 pb-2 border-bottom">
                <span className="text-muted small">CNI / Numéro d'identité : </span>
                <span className="text-secondary small fw-bold">{ debt?.cni }</span>
              </div>

              <div className="d-flex align-items-center gap-3 mb-2 pb-2 border-bottom">
                <span className="text-muted small">Téléphone du garant : </span>
                <span className="text-secondary small fw-bold">{ debt?.phone }</span>
              </div>
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer className="border-top gap-2">
        <button className="btn btn-sm btn-green px-3 me-4" onClick={onHide}>Fermer</button>
      </Modal.Footer>
    </Modal>
  )
}




export function StatContainer()
{
    const stats = AccountbilityApi(); 

    const fetchData = async () => { 
      const {data} = await stats.getAllStat();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["Statistics"], queryFn: fetchData });


    if (isLoading){
      return (
        <Row className="g-4 mb-5">
        {
          Array.from({ length: 4 }).map((_, index) => (
            <Col key={index} lg={6} md={6} sm={6} xs={12}>
              <Placeholder as="div" animation="glow" className="w-100 bg-secondary bg-opacity-25 rounded" style={{ height: '120px' }} />
            </Col>
          ))
        }
        </Row>
      )
    };
    if (error){
      return(
        <div className="text-center p-4 border alert alert-danger w-100 mb-5">
          Une erreur est survenue. Vueiller vérifier votre connexion 
        </div>
      )
    }


    return(

      <Row className="g-4 mb-5">
        <Col className='px-0' lg={6} md={6} sm={6} xs={12}>
          <Card className="stat-card h-100 rounded-0 border">
            <Card.Body className="text-center">
              <div className="stat-value text-secondary fs-5 mb-2" > {data.ordersValidated } </div>
              <div className="text-secondary"> Montant commande </div>
            </Card.Body>
          </Card>
        </Col>
        <Col className='px-0' lg={6} md={6} sm={6} xs={12}>
          <Card className="stat-card h-100 rounded-0 border">
            <Card.Body className="text-center">
              <div className="stat-value text-secondary fs-5 mb-2" > {data.maintenancesDone } </div>
              <div className="text-secondary"> Montant Maintenance </div>
            </Card.Body>
          </Card>
        </Col>
        <Col className='px-0' lg={6} md={6} sm={6} xs={12}>
          <Card className="stat-card h-100 rounded-0 border">
            <Card.Body className="text-center">
              <div className="stat-value text-secondary fs-5 mb-2" > { data.expenses } </div>
              <div className="text-secondary"> Montant dépense </div>
            </Card.Body>
          </Card>
        </Col>
        <Col className='px-0' lg={6} md={6} sm={6} xs={12}>
          <Card className="stat-card h-100 rounded-0 border">
            <Card.Body className="text-center">
              <div className="stat-value text-secondary fs-5 mb-2" > { data.debtsPaid } </div>
              <div className="text-secondary"> Montant créance </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

    )
}
